import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CreativeWidgetPageState} from './creativeWidgetPage.types';
import widgetAssetsReducer from './widgetAssets/widgetAssets.slice';
import {initialAssetDisplayState} from 'common/src/modules/Assets/Assets.types';

const initialState: CreativeWidgetPageState = {
  widgetAssets: initialAssetDisplayState,
  widgetId: null,
};

const creativeWidgetPageSlice = createSlice({
  name: 'creativeWidgetPage',
  initialState,
  reducers: {
    setWidgetId: (state, action: PayloadAction<number | null>) => {
      state.widgetId = action.payload;
    },
    resetState: () => initialState,
  },
});

// Custom reducer that handles widgetAssets state
const creativeWidgetPageReducer = (
  state: CreativeWidgetPageState = initialState,
  action: PayloadAction,
): CreativeWidgetPageState => {
  // Handle widgetAssets actions
  const widgetAssetsState = widgetAssetsReducer(state.widgetAssets, action);

  // Handle creativeWidgetPage slice actions
  const sliceState = creativeWidgetPageSlice.reducer(state, action);

  return {
    ...sliceState,
    widgetAssets: widgetAssetsState,
  };
};

export const {setWidgetId, resetState} = creativeWidgetPageSlice.actions;

export default creativeWidgetPageReducer;
